import styled from "@emotion/styled";
import { Box } from "@mui/material";

const NotificationViewedIndicator = styled(Box, {
  shouldForwardProp: (prop) => prop !== "viewed"
})<{ viewed: boolean }>(({ theme, viewed }) => ({
  backgroundColor: viewed
    ? theme.vars.palette.grey["400"]
    : theme.vars.palette.primary.main,
  borderRadius: "50%",
  height: "6px",
  width: "6px"
}));

export { NotificationViewedIndicator };
